<template>
  <Modal
    v-model="show"
    :width="width"
    class="addwin"
    :title="label"
    @on-cancel="close"
    @on-ok="submitForm"
  >
    <template #footer>
      <Button @click="cancel">取消</Button>
      <Button :loading="indexSpin.show" type="primary" @click="submitForm"
        >保存</Button
      >
    </template>
    <uformCreate
      ref="uformCreateRef"
      :hideConfirmBtn="true"
      :hideCancelBtn="true"
      :list="formInputList"
      :defaultValue="info"
      :labelPosition="labelPosition"
      :labelWidth="labelWidth"
      @submit="submit"
      @close="cancel"
    >
      <template #before>
        <slot name="before"></slot>
      </template>
      <template #after>
        <slot name="after"></slot>
      </template>
    </uformCreate>
  </Modal>
</template>

<script>
import request from "@/utils/request.js";
import { mapGetters } from "vuex";
export default {
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    info: {
      type: Object,
      default: () => null,
    },
    // 修改时用于更新视图数据
    row: {
      type: Object,
      default: () => null,
    },
    // 表单控件数据
    formInputList: {
      type: Array,
      default: () => [],
    },
    // 是否悬浮弹框
    isFixed: {
      type: Boolean,
      default: false,
    },
    // 新增接口
    addApi: {
      type: String,
      default: "",
    },
    // 更新接口
    updateApi: {
      type: String,
      default: "",
    },
    // 处理要保存的数据
    formatData: {
      type: Function,
      default: (res) => res,
    },
    // 是否查看状态
    isLook: {
      type: Boolean,
      default: false,
    },
    // 点击编辑按钮时哪些字段不解冻
    freezeField: {
      type: Array,
      default: () => [],
    },
    // 标题
    title: {
      type: String,
      default: "标题",
    },
    // 标题是否自动拼接
    titleSplicing: {
      type: Boolean,
      default: true,
    },
    width: {
      type: Number,
    },
    labelPosition: {
      type: String,
      default: "top",
    },
    labelWidth: {
      type: Number,
      default: 0,
    },
  },
  computed: {
    ...mapGetters(["indexSpin"]),
    label() {
      return this.titleSplicing
        ? this.info
          ? `编辑${this.title}`
          : `添加${this.title}`
        : this.title;
    },
  },
  watch: {
    value(newValue, oldValue) {
      this.show = this.value;
      this.show && this.init();
    },
  },
  data() {
    return {
      show: false,
    };
  },
  methods: {
    setDisabled(list, isDisabled, exclude = []) {
      list.forEach((i) => {
        if (!["title"].includes(i.type)) {
          if (!(!isDisabled && exclude.includes(i.field))) {
            i.disabled = isDisabled;
          }
        }
      });
    },
    init() {
      if (this.show && this.show.value && this.info && this.isLook) {
        this.setDisabled(this.formInputList, true);
      }
    },
    cancel() {
      this.$emit("cancel");
      this.close();
    },
    close() {
      this.$refs.uformCreateRef.resetForm();
      // this.show = false;
      this.$emit("close");
      this.$emit("input", false);
    },
    submit(res) {
      let postData = this.formatData(res);
      let api = this.info ? this.updateApi : this.addApi;
      request.post(api, postData).then((res) => {
        if (typeof res.result === "string") {
          this.$Message.success(res.result);
        }
        if (this.info) {
          Object.assign(this.row || this.info, postData);
          this.$emit("updataSuccess", res.result);
        } else {
          this.$emit("addSuccess", res.result);
        }
        this.close();
      });
    },
    submitForm() {
      this.$refs.uformCreateRef.submitForm();
    },
    tool() {
      return this.$refs.uformCreateRef.tool;
    },
  },
};
</script>

<style lang="scss" >
.addwin {
  .u-form-create {
    margin: 0 auto;
    max-width: 800px;

    .el-row {
      max-height: 60vh;
      overflow-y: auto;
    }

    .el-date-editor,
    .el-select,
    .el-input {
      width: 100%;
    }
  }

  .Form .title {
    font-size: 16px;
    font-weight: bold;
    margin-bottom: 15px;
    border-left: 3px solid #000;
    padding-left: 10px;
    line-height: 16px;
    height: 16px;
  }
}

.dark .addwin .Form .title {
  border-color: #ccc;
}
</style>
